import React from 'react'
import ArrowRightSvg from 'images/modules/Manage/i-arrow-right.svg?raw'

export { default as ArrowRightUrl } from 'images/modules/Manage/i-arrow-right.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowRightSvg}} />
)
